import React from 'react';
import { DefaultButton, Stack, Separator } from '@fluentui/react';
import PrimaryButton from '../Forms/PrimaryButton';

const NavigationalButtons = React.memo(({
  onNextHandler,
  onNextProps,
  onPrevHandler,
  onPrevProps,
  width,
  loading = false,
  height = 50,
  showSeparator = true
}) => {
  const showPrevious = Boolean(onPrevHandler || onPrevProps);
  const showNext = Boolean(onNextHandler || onNextProps);

  const stackStyles = {
    root: {
      height,
      width: width || 'auto',
    },
  };

  return (
    <>
      {showSeparator && <Separator />}
      <Stack
        horizontal
        styles={stackStyles}
        horizontalAlign={showPrevious ? "space-between" : "end"}
        verticalAlign="center"
      >
        {showPrevious && (
          <DefaultButton
            onClick={onPrevHandler}
            aria-label={onPrevProps?.text || "Previous button"}
            {...onPrevProps}
          >
            {onPrevProps?.text || "Prev"}
          </DefaultButton>
        )}
        {showNext && (
          <PrimaryButton
            btnType='button'
            text={onNextProps?.text || "Next"}
            loading={loading}
            onClick={onNextHandler}
            aria-label={onNextProps?.text || "Next button"}
            {...onNextProps}
          />
        )}
      </Stack>
    </>
  );
});

export default NavigationalButtons;
